import script from "./CardPackEditView.vue?vue&type=script&setup=true&lang=js"
export * from "./CardPackEditView.vue?vue&type=script&setup=true&lang=js"

import "./CardPackEditView.vue?vue&type=style&index=0&id=8ecf21a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ecf21a6"]])

export default __exports__